import { estabelecimento } from "../Estabelecimento/estabelecimento"
import { createElement, getUrlAction, track } from "../utils"


let deferredPrompt
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent no evento que exibe o install prompt
  e.preventDefault()
  // Salva o evento na variável.
  deferredPrompt = e
  //Verifica se já foi exibido antes e o cliente recusou
  const InstallPromotionDenied = localStorage.getItem(
    'InstallPromotionDenied'
  )

  if (!InstallPromotionDenied) {

  } else {
    deferredPrompt = undefined
  }
})


export const showInstallPromotion = () => {
  if (estabelecimento.logo && estabelecimento.fantasia && deferredPrompt && !estabelecimento.qrCode.ativo) {

    const template = `
    <img 
      src="${estabelecimento.logo}" 
      alt="logo" 
      style="
      border-radius: 6px;
    ">
    <svg class="close-banner" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" >
      <path d="M13.9175 1.34381L1.91748 13.3438" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M1.91748 1.34381L13.9175 13.3438" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
    <div class="u-margin-b-10">
      <div class="font-500 fonte-14">Instale o aplicativo na sua tela inicial</div>
      <div class="font-12 u-m-t-3">Facilite o acesso ao aplicativo adicionando-o à sua tela inicial. Assim, você poderá usá-lo de forma mais rápida e conveniente.</div>
    </div>
    <div class="flex-end flex gap-8 flex-wrap">
      <button id="instalar-app" class="btn-azul" style="width: 100%;">Instalar</button>
    </div>
      `

    const floatingMessage = createElement('div', { class: 'floating-message', }, template)
    
    const closeButton = floatingMessage.querySelector('.close-banner')
    closeButton.addEventListener('click', () => {
      floatingMessage.remove()
      localStorage.setItem('InstallPromotionDenied', 1)
      track("Recusou a instalação do app", { "Empresa": estabelecimento.fantasia });
    })

    const installPromotion = floatingMessage.querySelector('#instalar-app')
    installPromotion.addEventListener('click', () => {

      floatingMessage.remove()

      //Exibe o propt
      deferredPrompt.prompt()
      track("Clicou para installar o app", { "Empresa": estabelecimento.fantasia });
    })

    document.body.appendChild(floatingMessage)

    window.addEventListener('appinstalled', (evt) => {
      track("Instalou o app", { "Empresa": estabelecimento.fantasia });
    })

  }
}

